import axios from "axios";
import {
  USER_PERSONAL_INFO_FAIL,
  USER_PERSONAL_INFO_REQUEST,
  USER_PERSONAL_INFO_SUCCESS,
  GET_USER_PERSONAL_INFO_FAIL,
  GET_USER_PERSONAL_INFO_REQUEST,
  GET_USER_PERSONAL_INFO_SUCCESS,
} from "../../types/user/personalInfoTypes";

//Personal Info
export const userPersonalInfoAction =
  (formData) => async (dispatch, getState) => {
    try {
      dispatch({
        type: USER_PERSONAL_INFO_REQUEST,
      });
      const {
        sharedLogin: { sharedUserInfo },
      } = getState();
      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `${sharedUserInfo?.payload?.token}`,
        },
      };
      const { data } = await axios.post(
        `${process.env.REACT_APP_BACKEND_URI}/api/user/${sharedUserInfo?.empCompanies[0]?.companyId?._id}/personal/insert`,
        formData,
        config
      );
      // console.log(data);
      dispatch({
        type: USER_PERSONAL_INFO_SUCCESS,
        payload: data?.data,
      });
    } catch (error) {
      let err =
        error.response &&
        (typeof error.response.data === "string"
          ? error.response.data
          : error.response.data.message
          ? error.response.data.message
          : error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message);
      if (!err) {
        err = "Network Error";
      }
      //  console.log(err);
      dispatch({
        type: USER_PERSONAL_INFO_FAIL,
        payload: err,
      });
      throw Error(err);
    }
  };

//Change Password
export const getUserPersonalInfoAction =
  (companyId) => async (dispatch, getState) => {
    try {
      dispatch({
        type: GET_USER_PERSONAL_INFO_REQUEST,
      });
      const {
        sharedLogin: { sharedUserInfo },
      } = getState();
      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `${sharedUserInfo?.payload?.token}`,
        },
      };
      const { data } = await axios.get(
        `${process.env.REACT_APP_BACKEND_URI}/api/user/${companyId}/personal/data`,
        config
      );
      // localStorage.setItem(
      //   "personalUserInfo",
      //   JSON.stringify(data?.data, null, " ")
      // );
      dispatch({
        type: GET_USER_PERSONAL_INFO_SUCCESS,
        payload: data?.data,
      });
    } catch (error) {
      let err =
        error.response &&
        (typeof error.response.data === "string"
          ? error.response.data
          : error.response.data.message
          ? error.response.data.message
          : error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message);
      if (!err) {
        err = "Network Error";
      }
      //  console.log(err);
      dispatch({
        type: GET_USER_PERSONAL_INFO_FAIL,
        payload: err,
      });
      throw Error(err);
    }
  };
